import { computed, inject } from 'vue'

import { $blueprintQuestionTypesKey } from '../../utils/injections.ts'
import { type Blueprint } from './useBlueprint.ts'

export function useSelectableQuestionTypes(props: { blueprint: Blueprint; includeTypes?: string[] }) {
  const blueprintQuestionTypes = inject($blueprintQuestionTypesKey, [])

  const internalIncludeTypes = computed(() => {
    const types = props.includeTypes ?? []

    if (types.length > 0) {
      return new Set(types.filter((type) => blueprintQuestionTypes.includes(type)))
    }

    return new Set(blueprintQuestionTypes)
  })

  const selectableQuestionTypeOptions = computed(() => {
    let types = Object.keys(props.blueprint.questionTypeOptions)

    if (internalIncludeTypes.value.size > 0) {
      types = types.filter((type) => internalIncludeTypes.value.has(type))
    }

    const questionTypeOptions: Record<string, string> = {}
    for (const type of types) {
      questionTypeOptions[type] = props.blueprint.questionTypeOptions[type]
    }

    return questionTypeOptions
  })

  return { selectableQuestionTypeOptions }
}
